import styled from "@emotion/styled";
import { fontAngkor } from "@product/scmp-sdk";

import { ContentCoverImage } from "~/components/content/content-cover-image";
import { Figure } from "~/components/content/content-cover-image/styles";
import {
  Headline as ContentHeadline,
  SponsorHeadline,
} from "~/components/content/content-headline/styles";
import { EntityLink } from "~/components/entity-link";
import { Button } from "~/components/posties/button";
import { OffsetContainer } from "~/components/posties/offset-container";
import { setOffsetContainerCssVariables } from "~/components/posties/offset-container/styles";

export const StyledButton = styled(Button)``;

export const StyledContentCoverImage = styled(ContentCoverImage)`
  border-radius: 8px;
  ${props => props.theme.breakpoints.up("tablet")} {
    border-radius: 20px;
  }
`;

export const StyledOffsetContainer = styled(OffsetContainer)`
  margin-block-end: 5px;
  margin-inline-start: 5px;
  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 8px;
    margin-inline-start: 8px;
    ${setOffsetContainerCssVariables({ $borderRadius: "20px" })}
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    margin-block-end: 11px;
    margin-inline-start: 11px;
  }

  ${Figure} {
    position: relative;
    inset-block-start: 5px;
    inset-inline-end: 5px;

    inline-size: 100%;
    block-size: 100%;

    border-radius: 8px;

    ${props => props.theme.breakpoints.up("tablet")} {
      inset-block-start: 8px;
      inset-inline-end: 8px;

      border-radius: 20px;
    }
    ${props => props.theme.breakpoints.up("desktop")} {
      inset-block-start: 11px;
      inset-inline-end: 11px;
    }
  }
`;

export const Cover = styled.div``;

export const Headline = styled.div`
  margin-block-end: 8px;

  ${props => props.theme.breakpoints.up("desktop")} {
    margin-block-end: 12px;
  }

  ${ContentHeadline}, ${SponsorHeadline} {
    color: #1b4191;
    font-weight: 400;
    font-size: 32px;
    font-family: ${fontAngkor};
    font-family: Angkor;
    line-height: 32px;
    letter-spacing: -0.96px;

    ${props => props.theme.breakpoints.up("tablet")} {
      font-size: 36px;
      line-height: 40px;
      letter-spacing: -1.08px;
    }
  }
`;

export const DateContainer = styled.div`
  margin-block-end: 16px;

  color: #555555;
  font-weight: 400;
  font-size: 18px;
  font-family: Fredoka;
  font-style: normal;
  line-height: 24px;
  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 24px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 24px;
    line-height: 32px;
  }
`;

export const Content = styled.div``;

export const StyledEntityLink = styled(EntityLink)`
  display: grid;
  grid:
    "cover" min-content
    "content" min-content
    / 100%;
  gap: 29px;
  justify-content: center;
  align-items: center;

  ${Cover} {
    grid-area: cover;
  }

  ${Content} {
    grid-area: content;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    gap: 43px;
  }
`;

export const Container = styled.div``;
